<script setup>
import { computed, watch } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import FeaturePaywall from 'dashboard/routes/dashboard/settings/components/FeaturePaywall.vue';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const store = useStore();
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);
const currentAccountId = useMapGetter('getCurrentAccountId');
const getAccount = useMapGetter('accounts/getAccount');

const isAccountReady = computed(() =>
  Boolean(getAccount.value(currentAccountId.value)?.id)
);
const isBehindAPaywall = computed(
  () =>
    isAccountReady.value &&
    !isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.CAMPAIGNS
    )
);

watch(
  [isAccountReady, isBehindAPaywall],
  ([ready, paywalled]) => {
    if (!ready || paywalled) return;

    store.dispatch('campaigns/get');
    store.dispatch('labels/get');
  },
  { immediate: true }
);
</script>

<template>
  <div
    class="flex flex-col justify-between flex-1 h-full m-0 overflow-auto bg-n-surface-1"
  >
    <FeaturePaywall
      v-if="isBehindAPaywall"
      feature-prefix="CAMPAIGN"
    />
    <router-view v-else-if="isAccountReady" v-slot="{ Component }">
      <keep-alive v-if="keepAlive">
        <component :is="Component" />
      </keep-alive>
      <component :is="Component" v-else />
    </router-view>
  </div>
</template>
